import { useFullscreen } from './pwa';

/**
 * Asks a phone held upright to turn sideways.
 *
 * Shown instead of the HUD, not over it. The alternative — maintaining a
 * second, portrait control layout — means every instrument group and both
 * thumb zones need somewhere to live in a 390px-wide column, which is how the
 * readouts end up either stacked into a scrolling wall or cut down to
 * something that cannot fly the vessel. Landscape is the shape of the game;
 * the prompt is one tap of friction to get there.
 *
 * The game keeps running underneath — the simulation never pauses for the UI —
 * so turning the device shows the same moment, not a reload.
 */
export function RotatePrompt({ onDismiss }: { onDismiss: () => void }): JSX.Element {
  const fullscreen = useFullscreen();

  return (
    <div className="rotate-prompt">
      <div className="rotate-prompt-inner">
        <svg className="rotate-icon" viewBox="0 0 120 80" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="34" y="4" width="52" height="72" rx="6" strokeOpacity="0.35" />
          <rect x="4" y="14" width="112" height="52" rx="6" />
          <path d="M46 40h28M74 40l-7-6M74 40l-7 6" strokeOpacity="0.8" />
        </svg>
        <h1>Turn your device</h1>
        <p>
          Solar Frontier flies in landscape: the instruments sit along the bottom edge and both thumbs need a corner of
          their own.
        </p>
        <div className="button-row" style={{ justifyContent: 'center' }}>
          {fullscreen.supported && !fullscreen.active && (
            // Offered here because on Android the orientation lock only takes
            // effect while fullscreen — this button is what makes the rotation
            // stick rather than flipping back on the next tilt.
            <button type="button" onClick={fullscreen.toggle}>
              Fullscreen
            </button>
          )}
          <button type="button" onClick={onDismiss}>
            Continue in portrait
          </button>
        </div>
      </div>
    </div>
  );
}
